export default "__VITE_ASSET__035bTAkx__"